import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../core/services/user.service';
import { BrandingService } from '../core/services/branding.service';
import { MsalService } from '@azure/msal-angular';
import { AuthorizationService } from '../core/services/authorization.service';
import { Permission } from '../global/policy-types';
import { AuthenticationService } from '../core/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  isExternalUser: boolean = false;
  userName: string = '';

  constructor(private _router: Router,
    private _userService: UserService,
    private _brandingService: BrandingService,
    private _msalService: MsalService,
    private _authenticationService: AuthenticationService,
    private _authorizationService: AuthorizationService) {
  }
  async canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):Promise<boolean> {

    if ((await this._authenticationService.getAccessToken()) == undefined) {
      return false;
    }

    this.isExternalUser = this._authorizationService.hasPermission(Permission.ProgramHub) ?? false;

    //Getting Account Info to ensure user is already logged in to the app.
    const account = this._msalService.instance.getAllAccounts()[0];
    const isProgramHub = this._brandingService.isProgramHub;
    const isExternalUrl = route.data['externalUrl'];
    const isImpersonating = this._authenticationService.isImpersonating;

    //Checking the External User and Unauthorized Pages using route.data['externalUrl'] 
    // is added in the route module
    // and Application is Program Hub 
    // and Redirecting to the Root Page.
    if (account && this.isExternalUser && !isExternalUrl && isProgramHub) {


      //Setting the sessionStorage to false. To Show the Warning Banner.
      sessionStorage.setItem('warningBannerDismissed__customer-overview', 'false');

      //Navigating to the Root Page.
      this._router.navigate(['/customer-overview']);
      return false;
    }

    // TODO: Refactor the logic to reduce the cyclomatic complexity (too many IF-THEN-ELSE).
    // A quick fix but increases cyclomatic complexity. Needs refactoring.
    else if (account && !this.isExternalUser && isExternalUrl && !isProgramHub && isImpersonating) {
      return true;
    }
   
    //If User is External (non-impersonated) and Application is not Program Hub then return false.
    //then we get the different warning message.
    //That is already added in App.component.
    else if (account && this.isExternalUser && !isProgramHub && !isImpersonating) {
      return false;
    }

    return true;
  }

  /**
   * Retrieves the username asynchronously.
   * 
   * This method returns a promise that resolves to the username after a delay of 1.5 seconds.
   * It checks the accounts from the MSAL service instance and retrieves the username from the user service if accounts are found.
   * 
   * @returns {Promise<string>} A promise that resolves to the username.
   */
  async getUserName(): Promise<string> {
    let name = '';
    return new Promise((resolve) => {
      setTimeout(() => {
        const accounts = this._msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          name = this._userService.getUsername() ?? '';
        }
        resolve(name);
      }, 1500); // Delay of 1.5 second
    });
  }
};